import React, { useEffect, useState } from "react";
import { makeAuthenticatedGet } from "../utils/fetchUtils";
import { GET_USER_INFO } from "../utils/constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IUser } from "../utils/types";
import AccessibilityAccordion from "./AccessibilityAccordion";
import nclude from "../assets/nclude-color.svg";
import logout from "../assets/logout.svg";
import person from "../assets/person-circle.svg";
import { clearGuestLoginPromptHistory } from "../utils/guestSession";

// Define the props interface
interface props {
  activePage?: string;
  curr?: number;
  changeCategory?: (category: string) => any;
  setShelf?:(shelf:any) => any;
  menuRef?: any;
}


const Header = (props: props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userDetails, setUserDetails] = useState<IUser>();
  const [isLoggedIn, setIsLoggedIn] = useState(() => Boolean(localStorage.getItem("token")));
  const active = props.activePage;
  const [currPage,setCurrPage] = useState(props.curr!); //0: new request 1: prev requests  

  useEffect(() => {
    if (isLoggedIn === true) {
      fetchUserDetails();
    }
  }, [isLoggedIn]);

  const fetchUserDetails = async () => {
    try {
      const resp = await makeAuthenticatedGet(GET_USER_INFO);
      //  console.log(resp);
      if (resp.success && resp.user) {
        setUserDetails(resp.user);
        if (resp.user.phoneNumber) localStorage.setItem("userPhoneNumber", resp.user.phoneNumber);
        if (resp.user.email) localStorage.setItem("userEmail", resp.user.email);
      }
    } catch (error) {}
  };

  const handleLogout = () => {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
      localStorage.removeItem("resume");
      localStorage.removeItem("scope");
      localStorage.removeItem("userId");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userPhoneNumber");
      clearGuestLoginPromptHistory();
      setIsLoggedIn(false);
      setUserDetails(undefined);
      navigate("/");
    }
  };

  const User = () => {
    return (
      <>
        {/* <button role='link' onClick={handleProfileBtn}>{userDetails?.userName}</button> */}
        <Link to="/profile" className="user-name d-flex align-items-center" aria-label={`Open profile for ${userDetails?.userName || "your account"}`}>
          {userDetails?.userName || "Account"}
          <span className="profile-pic" aria-hidden="true">
            <img src={person} alt="" />
          </span>
        </Link>
      </>
    );
  };

  const Admin = () => {
    return <></>;
  };

  const Org = () => {
    return (
      <>
        {/* <button role='link' onClick={handleOrgProfileBtn}>{userDetails?.userName}</button> */}
        <Link to="/orgProfile">{userDetails?.userName}</Link>
      </>
    );
  };

  function toggleToFirstOption(): void {
    setCurrPage(0);
  }

  function toggleToSecondOption(): void {
    setCurrPage(1);
  }

  useEffect(()=> {
    if(active === 'av') {
      if(currPage === 0) {
        navigate('/avaccess/new');
      } else {
        navigate('/avaccess');
      }
    }else if(active === 'jobs') {
      // if(currPage === 0) {
      //   props.changeCategory?.('government_job');
      // } else {
        props.changeCategory?.('corporate_job');
      // }
    } else if(active === 'lib') {
      if(currPage === 0) {
        props.setShelf?.(false);
      }else{
        props.setShelf?.(true);
      }
    }

  },[currPage])

  return (
    <header className="flex justify-between text-xl header">
      <nav className="d-flex align-items-center w-[16%]" style={{ paddingLeft:'0.5rem'}} aria-label="Home">
        <div className="header-logo-container">
          <Link to="/" className="logo" aria-label="Nclude home">
            <img src={nclude} alt="Nclude logo" className="logo" />
          </Link>
        </div>
      </nav>
      {(active === 'av') && <div className="accessibility-header" id="accessibility-menu" tabIndex={-1}>
        <button type="button" tabIndex={0} className={currPage === 0 ? "active-accessibility-header":"" } onClick={()=> toggleToFirstOption()}>Convert Audio/Video</button>
        <button type="button" tabIndex={0} className={currPage === 1 ? "active-accessibility-header":"" } onClick={()=> toggleToSecondOption()}>Previous Requests</button>
      </div>}
      {(active === 'lib') && <div className="accessibility-header" id="library-menu" tabIndex={-1}>
        <button type="button" tabIndex={0} className={currPage === 0 ? "active-accessibility-header":"" } onClick={()=> toggleToFirstOption()}>Browse All Books</button>
        <button type="button" tabIndex={0} className={currPage === 1 ? "active-accessibility-header":"" } onClick={()=> toggleToSecondOption()}>Book Shelf</button>
      </div>}
      <div className="d-flex w-[21.875rem] justify-evenly right-half">
        <div className="accessibility-settings d-flex align-items-center">
          <AccessibilityAccordion />
        </div>
        {/* <button aria-label="Home" role='link' onClick={handleHomeBtn} className='mx-12'>Home</button> */}
        {/* <Link to="/" className="mx-12 align-self-center">
          Home
        </Link> */}
        {isLoggedIn ? (
          <>
            <button
              type="button"
              aria-label="Sign out"
              onClick={handleLogout}
              className="logout"
            >
              <img src={logout} alt="" aria-hidden="true" style={{ width: "1.5rem"}}/>
            </button>
            <div className="d-flex justify-evenly items-center pr-6">
              {(!userDetails || userDetails.role === "user") && <User />}
              {userDetails?.role === "admin" && <Admin />}
              {userDetails?.role === "org" && <Org />}
            </div>
          </>
        ) : (
          <div className="guest-account" aria-label="Account">
            <span>Guest</span>
            <Link to="/login" state={{ returnTo: location.pathname }} className="guest-sign-in-link">
              Sign in
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
